import client from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for pest
const PEST_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.PEST,
  false // No tenant ID in the base URL
);

export const getPestList = () => client.get(`${PEST_BASE}/list`);
